import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers'; // Assume you have a root reducer

const store = configureStore({
  reducer: rootReducer, // Your root reducer
  // Optionally, you can provide middleware, devTools, etc. here
});

export default store;